import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { cisloOnly20RegExp } from 'enums/regExp';

export const numberValidation = (hasToBeMoreThanZero?: boolean) => [
    () => ({
        validator(_: RuleObject, value: string | number) {
            if (hasToBeMoreThanZero && (value + '')[0] === '0')
                return Promise.reject(<TranslateText>NEVALIDNI_PROCENTA_100_06_0</TranslateText>);
            if (!value || cisloOnly20RegExp.test(String(value))) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_NUM</TranslateText>);
        }
    })
];

export default numberValidation;
